import { render, staticRenderFns } from "./RouterComponent.vue?vue&type=template&id=3f6842de&"
import script from "./RouterComponent.vue?vue&type=script&lang=js&"
export * from "./RouterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports